import { MembersState, membersAdapter } from './members.interfaces';

export const membersInitialState: MembersState = membersAdapter.getInitialState({
  ids: [],
  entities: {},
  errors: null,
  isLoading: false,
});
